import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fill-height d-flex flex-column" }
const _hoisted_2 = { class: "d-flex mb-4" }
const _hoisted_3 = { class: "d-flex flex-grow-1" }
const _hoisted_4 = { class: "scrollable-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_download_button_with_pop_up = _resolveComponent("download-button-with-pop-up")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_simple_station_table = _resolveComponent("simple-station-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_parameter_card = _resolveComponent("parameter-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_spacer),
      _createVNode(_component_download_button_with_pop_up, {
        title: _ctx.t('download_form.station_metadata'),
        testid: 'station-metadata',
        outlined: "",
        "format-choices": [{ title: 'CSV', value: 'csv' }],
        "file-suffix": ' ' + _ctx.t('download_form.station_metadata'),
        onDownload: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadStationMetadata($event)))
      }, null, 8, ["title", "file-suffix"]),
      _createVNode(_component_download_button_with_pop_up, {
        title: _ctx.t('download_form.parameter_metadata'),
        testid: 'station-parameter-metadata',
        outlined: "",
        "format-choices": [{ title: 'CSV', value: 'csv' }],
        "file-suffix": ' ' + _ctx.t('download_form.parameter_metadata'),
        onDownload: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadParameterMetadata($event)))
      }, null, 8, ["title", "file-suffix"]),
      _createVNode(_component_download_button_with_pop_up, {
        title: _ctx.t('download_form.dataset'),
        testid: 'station-data',
        "format-choices": [
          { title: 'CSV', value: 'csv' },
          { title: 'GeoJSON', value: 'json' },
        ],
        "file-suffix": ' ' + _ctx.t('download_form.dataset'),
        "default-start-date": _ctx.stationStore.filters.startDate,
        "default-end-date": _ctx.stationStore.filters.endDate,
        "show-date-picker": true,
        "date-picker-text-field-props": {
          'error-messages': _ctx.dateRangeTextFieldErrorMsg,
        },
        "disable-download-button": !!_ctx.dateRangeTextFieldErrorMsg,
        onDownload: _cache[2] || (_cache[2] = ($event: any) => (_ctx.downloadDataset($event))),
        onDateRangeChanged: _ctx.generateDateRangeTextFieldErrorMsg
      }, null, 8, ["title", "file-suffix", "default-start-date", "default-end-date", "date-picker-text-field-props", "disable-download-button", "onDateRangeChanged"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_v_card, { class: "width-50 mr-2 station-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "zamg-text-headline" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.stationCardTitle), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "fill-height d-flex flex-column" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_simple_station_table, {
                  class: "mt-4 station-table",
                  items: _ctx.stationStore.selectedStations,
                  "is-loading": false,
                  "disable-pagination": "",
                  "hidden-header-names": [
                'state',
                'altitude',
                'hasSunshine',
                'hasGlobalRadiation',
                'isActive',
              ],
                  "grey-out-unmatched-substations": false,
                  "hide-top-divider": true
                }, null, 8, ["items"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_parameter_card, {
        class: "station-card ml-2",
        title: _ctx.parameterCardTitle,
        items: _ctx.parameterStore.selectedParameters,
        selected: [],
        "show-select": false,
        "show-search": false
      }, null, 8, ["title", "items"])
    ])
  ]))
}